import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const updateMacroContent = api(async function updateMacroContent({ id, content }) {
    if (!id) return false
    return mutate(
        gql`
            mutation UpdateMacroContent($id: String!, $content: String!) {
                updateMacroContent(id: $id, content: $content)
            }
        `,
        { id, content },
        { returns: "updateMacroContent" }
    )
})
